import km from 'keymirror'
import _ from 'underscore'
import { getHostName } from '../util/function.js'

export default _.extend({
  COUPON_SHOW_USEFUL: 1,
  COUPON_SHOW_USED: 3,
  COUPON_SHOW_OVERDUE: 2,
  COUPON_INSTRUCTIONS_URL: `${getHostName()}/act/active/1243`, //现金券说明页链接地址
}, km({
  COUPON_BINDINGCOUPON_SUCCESS: null,
  COUPON_BINDINGCOUPON_ERROR: null,
  COUPON_GETCOUPONLIST_SUCCESS: null,
  COUPON_GETCOUPONLIST_ERROR: null,
  COUPON_GETCOUPONCOUNT_SUCCESS: null,
  COUPON_GETCOUPONCOUNT_ERROR: null,
  /*yeoman-template-point-1*/
}))
